import { render, staticRenderFns } from "./que-faire-en-cas-de-perte-ou-de-vol-de-votre-permis-de-conduire.vue?vue&type=template&id=890490f8&"
import script from "./que-faire-en-cas-de-perte-ou-de-vol-de-votre-permis-de-conduire.vue?vue&type=script&lang=js&"
export * from "./que-faire-en-cas-de-perte-ou-de-vol-de-votre-permis-de-conduire.vue?vue&type=script&lang=js&"
import style0 from "./que-faire-en-cas-de-perte-ou-de-vol-de-votre-permis-de-conduire.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer,VFlex,VLayout})
